import React from "react";
import * as Mui from "@mui/material";
export const CustomTextBox = ({
  type,
  rules,
  selectedValue,
  label,
  placeHolder,
  textBoxError,
  errorMessage,
  updateDataFunction,
  disabledValue,
  onBlurFunction,
  minDate,
}) => {
  return (
    <Mui.TextField
      type={type}
      multiline={type === "multiline" ? true : false}
      rows={type === "multiline" ? 3 : 1}
      label={label}
      placeholder={placeHolder}
      value={selectedValue}
      rules={rules}
      size="small"
      onChange={(event) => {
        updateDataFunction(event);
      }}
      onBlur={onBlurFunction}
      InputLabelProps={{ shrink: true }}
      error={textBoxError}
      helperText={errorMessage}
      InputProps={{
        readOnly: disabledValue,
        style: {
          color: "black",
          cursor: "text",
          userSelect: "all",
        },
      }}
      inputProps={{
        ...(type === "date" && {
          min: minDate,
        }),
      }}
      fullWidth
    />
  );
};
